var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-form-part"},[_c('ServiceRadioField',_vm._g({attrs:{"choices":_vm.choices},on:{"result":function($event){return _vm.setMarketSegmentForService($event.value[0])}}},_vm.$listeners)),_vm._v(" "),_c('MarketSegmentField',_vm._g({ref:"marketSegment",attrs:{"hidden":""}},_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }